import { injectable } from 'inversify';
import { Component, ObjectManager } from '../../../concepts/objects';
import { resolve } from '../../Container';
import { EditorSession } from '../EditorSession';
import { Selection } from '../Selection';
import { ContentPayload } from './ContentPayload';
import { ContentProcessor } from './ContentProcessor';
import { DeqoStyleData } from './DeqoData';

@injectable()
export class DeqoStyleDataProcessor implements ContentProcessor {

    @resolve(ObjectManager) private objects!: ObjectManager;
    @resolve(EditorSession) private session!: EditorSession;

    public readonly supportedTypes = Object.freeze([
        'x/deqo-styles',
    ]);

    public async process({ data }: ContentPayload): Promise<boolean | ContentPayload> {

        const styles = DeqoStyleData.unwrap(data);
        const selection = this.session.get(Selection);
        if (!selection.size) return true;

        this.objects.update(() => {
            for (const c of selection) {
                const ct = Component.describe(c);
                const cs = styles[ct.name];
                if (!cs) continue;
                for (const k of Object.keys(cs)) {
                    const cp = ct.properties.find(x => x.name === k && !!x.style);
                    if (!!cp) c.set(cp.name, cs[k]);
                }
            }
        });

        return true;
    }
}
